import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import { FormControl } from "react-bootstrap";
import "./JobSaveSalaryForm.scss";
import EmploymentTypeEnum, {getEmploymentTypeLabel} from "../EmploymentTypeEnum";

export default function JobSaveSalaryForm({t, loading, employmentType, onChange}) {
  useShowLoader(loading);

  return (
    <div className="JobSaveSalaryForm spaced-children widget-block">
      <Row>
        <Col className={"label-col"}>
          <div className="label-div">
            <p className="label">
              {t("jobs:employers_job_save_salary_employment_type_label")}
            </p>
            <FormControl
              as={"select"}
              custom
              name={"employmentType"}
              onChange={onChange}
              value={employmentType}
              className={"employmentType-input"}
            >
              {Object.values(EmploymentTypeEnum).map((employmentType) => (
                <option key={employmentType} value={employmentType}>
                  {getEmploymentTypeLabel(t, employmentType)}
                </option>
              ))}
            </FormControl>
          </div>
        </Col>
      </Row>
    </div>
  );
}
